import React, { useCallback, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import throttle from 'lodash/throttle';
import { Summary } from './components/summary';
import { List } from './components/list';
import classes from './giveaway-landing-goodie-selected-products.scss';
export const GiveawayLandingGoodieSelectedProducts = ({
  selectedProductsTotal,
  budgetTotal,
  products,
  link,
  isInvalidTotal,
  onProductRemoveClick,
  amountColor,
  giveawayColor
}) => {
  const headerPositionRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const throttledHandler = throttle(handleScroll, 300);
    window.addEventListener('scroll', throttledHandler);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', throttledHandler);
    };
  }, []);
  const handleScroll = useCallback(() => {
    if (headerPositionRef.current) {
      const shouldBeSticky = window.pageYOffset > headerPositionRef.current.offsetTop;
      setIsSticky(shouldBeSticky);
    }
  }, []);
  const handleRemoveClick = product => {
    onProductRemoveClick(product, link);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.headerContent,
    ref: headerPositionRef
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(classes.container, {
      [classes.sticky]: isSticky
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(Summary, {
    isInvalidTotal: isInvalidTotal,
    selectedTotal: selectedProductsTotal,
    budgetTotal: budgetTotal,
    amountColor: amountColor,
    giveawayColor: giveawayColor
  }), /*#__PURE__*/React.createElement(List, {
    list: products,
    onRemoveClick: handleRemoveClick,
    giveawayColor: giveawayColor
  }))));
};